"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgGasCan64 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h64v64H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "m41 27.5-15 15m0-15 15 15m-5.11-26h6.52a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-7.486a.922.922 0 0 1-.719-1.5l.905-1.126a1 1 0 0 1 .78-.374Zm-9.802 2.003 2.832-.003c.936 0 2.54-1.32 4.814-3.961a3.931 3.931 0 0 1 2.66-1.039h5.65c2.185 0 3.956 1.792 3.956 4.003v29.994c0 2.144-1.666 3.894-3.76 3.998l-.222.005-18.086-.116C21.756 51.37 20 49.582 20 47.38V24.254l6.088-5.75Zm-5.806 4.994L18 21.071l4.885-4.556 2.281 2.426", stroke: "currentColor" })] })) }))); };
exports.default = SvgGasCan64;
